import useUser from "@hooks/useUser"

import { Hint } from "@atoms/index"

import { useNotificationMethodsQuery } from "@pages/Settings/SettingsNotifications/components/NotificationMethodsSection/NotificationMethodsSection.store"

import { SMSNotificationTooltipProps } from "./SMSNotificationTooltip.types"

export default function SMSNotificationTooltip(props: SMSNotificationTooltipProps) {
    const { children } = props

    // The form library checks all the checkboxes when initial data is loaded, triggering hints.
    const { user } = useUser()

    const { data: defaultMethodsPreference } = useNotificationMethodsQuery()

    const hasPhone = (user?.phone ?? "") !== ""
    const hasVerifiedPhone = hasPhone && (user?.phone_verified ?? false)

    const tooltipTitle = hasPhone
        ? hasVerifiedPhone
            ? "Notification method is off"
            : "Phone number not verified"
        : "No phone number"
    const tooltipColorScheme = hasVerifiedPhone || !hasPhone ? "tomato" : "amber"
    const tooltipMessage = hasPhone
        ? hasVerifiedPhone
            ? "This can't be edited because the related notification method is off. Turn the method on to manage these topics."
            : "Verify your phone number to turn on text message notifications."
        : "Set your phone number to turn on text message notifications."

    return (
        <Hint
            colorScheme={tooltipColorScheme}
            title={tooltipTitle}
            body={tooltipMessage}
            isDisabled={hasVerifiedPhone && (defaultMethodsPreference?.contact_sms ?? false)}
            defaultPlacement="right"
        >
            {children}
        </Hint>
    )
}
